import { type PayloadAction, createSlice } from '@reduxjs/toolkit';


interface PendingUserSlice {
    firstName?: string,
    hasHandicapCard?: boolean,
    language?: string,
    lastName?: string,
    phoneNumber?: string,
    profilePic?: string,
    location?: {
        street: string;
        additional?: string;
        zipcode: string;
        city: string;
        country: string;
    }
    hasConsented?: boolean;
}

export type { PendingUserSlice };

const initialState: PendingUserSlice = {
    firstName: '',
    hasConsented: false,
    hasHandicapCard: false,
    language: '',
    lastName: '',
    location: {
        additional: '',
        city: '',
        country: '',
        street: '',
        zipcode: '',
    },
    phoneNumber: '',
    profilePic: '',
};

const pendingUserSlice = createSlice({
    initialState,
    name: 'pending-user',
    reducers: {

        // Clear the pending user user
        clearPendingUser: () => {
            return initialState;
        },

        setPendingUser: (state, action: PayloadAction<PendingUserSlice>) => {
            return action.payload;
        },           

        updatePendingUserProps: (state, action: PayloadAction<{ field: string, value: string }>) => {
            const { field, value } = action.payload;
            let nState = { ...state };

            if (!action.payload.field.includes('.')) {
                nState = {
                    ...state,
                    [field]: value // Update the field
                };
                return nState;
            }

            // Split field into nested parts
            const fieldParts = field.split('.');

            // If field is nested
            if (fieldParts.length > 1) {
                const topLevelField = fieldParts[0];

                const nestedFields = fieldParts.slice(1); // Remove the first part (top-level field)

                // Create a new object with updated nested fields
                const updatedNestedFields = {
                    ...state[topLevelField], // location
                    [nestedFields.join('.')]: value // Update the nested field
                };

                // Return the new state with updated superGroupConfig
                state.location = updatedNestedFields;

                return state;
            }
        },
    },
});

// Export the action creators and reducer
export const { setPendingUser, clearPendingUser, updatePendingUserProps } = pendingUserSlice.actions;
export default pendingUserSlice.reducer;
